import React from "react";
import { renderImage } from "../../util/imageRenderer";
import { FaPrint } from "react-icons/fa6";

export const StripNone = () => {

  return (
    <React.Fragment>
        <div className={`w-full mx-auto rounded-lg my-2 h-[40px] py-2 border-solid border-2 border-[#B8B8B8] text-[#dbdbdb] `}>
                  <p className=" my-auto font-bold m-3 w-[33%] text-left " >???</p>
        </div>
        <div className="flex flex-row h-[70px] w-[97%] text-[#dbdbdb] mb-1 text-center rounded-[10px] border-solid border-2 border-[#B8B8B8] mx-auto">
          <div className="w-[8%]">
            <div className="h-[90%] content-center font-[24px] text-[1vw] border-[#B8B8B8] border-[2px] rounded-l-[8px] m-1   ">
              ??/??
            </div>
          </div>

          {renderImage("none")}
          <div className="h-[40px] w-[2px] bg-[#B8B8B8] my-auto mt-[15px]"></div>
          {renderImage( "none")}
          <div className="w-[23%] content-center">
            <div className="flex h-[90%]    justify-center items-center border-solid border-2 border-[#B8B8B8]">
              <p className="text-[2.5vw] font-bold ">
              0000
              </p>
            </div>
          </div>
          {/* ----------------------------------------Show IMG----------------------------------------------------- */}
         
          {/* --------------------------------------------------------------------------------------------- */}
          {renderImage( "none")}
          {/* --------------------------------------------------------------------------------------------- */}
          <div className="w-[28%] content-center">
          <p className="text-[1vw] font-bold text-black">
              
              </p>
              </div>
          {/* -----------------------------------------print update---------------------------------------------------- */}
          <button
            className=" w-[20%] h-[90%]  content-center rounded-r-[8px] m-1 border-solid border-2 border-[#B8B8B8] "
            // disabled={y.stop || y.print}
          >
            <FaPrint className=" text-[2vw]" />
          </button>
          {/* --------------------------------------------------------------------------------------------- */}
        </div>
    </React.Fragment>
  );
};
